import { useState } from "react";

import Text from "ab-text";

const EscapadaDetail = ({ itm, isOpen }) => {
  const [open, setOpen] = useState(isOpen);
  return (
    <div className={`escapada-detail ${open ? "" : "closed"}`}>
      <div className="row">
        <div>
          <Text element="h3">{itm.nombre}</Text>
          {itm.subtitulo ? (
            <Text element="span" className="title">
              {itm.subtitulo}
            </Text>
          ) : null}
        </div>

        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => setOpen(!open)}
        >
          <circle
            cx="20.334"
            cy="20.5"
            r="20"
            transform="rotate(90 20.334 20.5)"
            fill="#E3DECF"
          />
          {open ? (
            <path
              d="M25.3536 22.1869C25.176 22.3644 24.8983 22.3806 24.7025 22.2353L24.6464 22.1869L20.3333 17.874L16.0202 22.1869C15.8427 22.3644 15.5649 22.3806 15.3692 22.2353L15.3131 22.1869C15.1356 22.0094 15.1195 21.7316 15.2647 21.5359L15.3131 21.4798L19.9798 16.8132C20.1573 16.6356 20.4351 16.6195 20.6308 16.7647L20.6869 16.8132L25.3536 21.4798C25.5488 21.6751 25.5488 21.9917 25.3536 22.1869Z"
              fill="#A79669"
            />
          ) : (
            <path
              d="M14.9804 18.3131C15.1579 18.1356 15.4357 18.1195 15.6315 18.2647L15.6875 18.3131L20.0007 22.626L24.3138 18.3131C24.4913 18.1356 24.7691 18.1195 24.9648 18.2647L25.0209 18.3131C25.1984 18.4906 25.2145 18.7684 25.0693 18.9642L25.0209 19.0202L20.3542 23.6869C20.1767 23.8644 19.8989 23.8806 19.7032 23.7353L19.6471 23.6869L14.9804 19.0202C14.7852 18.825 14.7852 18.5084 14.9804 18.3131Z"
              fill="#A79669"
            />
          )}
        </svg>
      </div>

      <Text>{itm.descripcion}</Text>
      <ul>
        {itm.incluye.map((itm) => (
          <li>{itm?.texto}</li>
        ))}
      </ul>

      {itm.precio ? (
        <Text element="span" className="title">
          {itm.precio}
        </Text>
      ) : null}
    </div>
  );
};

export default EscapadaDetail;
